import getDomainUserId from 'utils/snowplow/getDomainUserId'
import store from 'utils/store/withMiddleware'
import storage from 'proxy-storage'

const fromMember = (member, suffix) => {
  const parseMap = {
    fname: 'firstName',
    lname: 'lastName',
    email: 'email',
    phone_number: 'phone',
    gender: 'gender',
    dob: 'stringDOB'
  }

  return Object.entries(parseMap).reduce((acc, [key, value]) => {
    const memberKey = `${key}${suffix}`
    if (member[value]) {
      acc[memberKey] = member[value]
    }
    return acc
  }, {})
}

const parseUser = state => {
  let hcStorage = state.hcStorage
  if (!hcStorage.members || hcStorage.members.length === 0) {
    const fromProxy = storage.getItem('hc')
    if (fromProxy && fromProxy.members && fromProxy.members.length > 0)
      hcStorage = fromProxy
  }

  const members = hcStorage.members
  if (!members || !members.length) {
    return undefined
  }

  const primaryMember = members.find(m => m.id === 'primary')
  if (!primaryMember) {
    return undefined
  }
  let user = fromMember(primaryMember, '')
  if (!user.email) {
    user.email = hcStorage.contact.email_address
  }

  const spouse = members.find(m => m.id === 'spouse')
  if (spouse)
    user = {
      ...user,
      ...fromMember(spouse, '_s')
    }

  return user
}

const parseQuote = state => {
  const location = state.hcStorage.location
  if (!location) {
    return undefined
  }

  const quote = {
    ...location
  }

  ;['planId', 'policies', 'sDate', 'endDate'].forEach(key => {
    if (state[key]) {
      quote[key.toLowerCase()] = `${state[key]}`
    }
  })

  return quote
}

const parseBrowser = state => {
  let browser

  if (state.hcStorage.utm)
    browser = {
      ...browser,
      ...state.hcStorage.utm
    }

  const domainUserId = getDomainUserId()
  if (domainUserId) {
    browser = {
      ...browser,
      userId: domainUserId
    }
  }

  return browser
}

export default function readFromState(): Pivot.Session | undefined {
  const state = store.getState()
  const { hcStorage, enrollment } = state

  const session = hcStorage.session || {}

  const user = parseUser(state)
  if (user) {
    session.user = user
  }

  const quote = parseQuote(state)
  if (quote) {
    session.quote = quote
  }

  const browser = parseBrowser(state)
  if (browser) {
    session.browser = browser
  }

  if (enrollment) {
    session.cart = enrollment
  }

  return session
}
